import logo from './logo.svg';
import './App.css';
import { Bubble } from "@typebot.io/react";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Inquirly ChatBot Test
        </p>
      </header>
    </div>
  );
}

export default App;
